// extracted by mini-css-extract-plugin
export default {"information":"uxj4UY0mXQ","icon":"V6RaDchl9j","label":"yKmqTxENxZ","time":"ADHKBrk4Ji","location":"CfIiY3pPVL","buttonList":"pCP9HqQTra","openCalender":"FYou223I2P"};